import React, { Component } from 'react';
import { loadJS, getMultiLang } from '@platform/api';
import "./index.less";

class NCImportPage extends Component {
    state = {};
    UNSAFE_componentWillMount() {
        //加载多语
        let callback = json => {
            this.setState({ json });
        };
        getMultiLang({ moduleId: "page_table", callback });
    }
    componentDidMount(){
        if(!window['runtime']) {
            loadJS(
                '../../../../lowcode/light-front/runtime/main/runtime.js',
                () => {
                    try {
                        let component = window['runtime'].ParseLayoutComponent;
                        this.setState({ component });
                    } catch (e) {console.log(e);}
                },
                () => {
                    this.setState({ errorMsg: '加载失败' });
                },
            );
        }else{
            let component = window['runtime'].ParseLayoutComponent;
            this.setState({ component });
        }
    }

    renderNoData = ()=> {
        return (
            <span className='no-data-container'>
                <img src={require('../../static/images/pageMainIcon/nodata.png')}></img>
                <span>{this.state.json["table0033"] || '暂无数据'}</span>
            </span>
        );
    }
    
    render() {
        let { isLowCode, moduleId, importAppCode, importPageCode, noData } = this.props;
        let { component } = this.state;
        if(!isLowCode || (!importAppCode || !importPageCode) ){
            return <div className='importpage-container' {...this.props}></div>;
        }
        return (
            <React.Fragment>
                {component ? (<div className={`${noData ? 'show-no-data' : ''} importpage-container`}>
                    { noData && this.renderNoData()}
                    {React.createElement(component, 
                        { 
                            ...this.props,
                            parseLayoutModuleId: moduleId,
                            appCode: importAppCode,
                            pageCode: importPageCode,
                        })}
                </div>) : this.renderNoData()}
            </React.Fragment>
        );
    }
}

export default NCImportPage;
